import Vue from "vue";
import PayDetail from "./PayDetail"
export default Vue.extend({
    template: `
        <div> 
          <PayDetail :params='params'></PayDetail>
        </div>
    `,
    data: function() {
        return {
            info: {}
        };
    },
    components: {
        PayDetail
    },
    beforeMount() {},
    mounted() {},
    methods: {
        // called when the cell is refreshed
        refresh() {
            return false;
        },
    }
});